module.exports = __webpack_public_path__ + "img/Z.d413b25a.jpg";